<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,
body,
#app {
  width: 100%;
  height: 100%;
  margin: 0;
}
</style>
